import { activityPlatform, activitySite } from '@/shared/api/generated/activity/activity';
import { useSiteScope } from '@/app/site/useSiteScope';
import { ActivityFeed, type ActivityPage, type Cursor } from '@/features/activity/ActivityFeed';
import { t } from '@/shared/i18n';
import { EmptyState } from '@/shared/ui/EmptyState';

import styles from './ActivityPage.module.scss';

async function unwrapPage(
  request: Promise<{ status: number; data: unknown }>,
): Promise<ActivityPage> {
  const response = await request;

  if (response.status !== 200) {
    throw new Error('Неожиданный ответ на запрос журнала');
  }

  return response.data as ActivityPage;
}

/** Журнал сайта — тем, кто управляет его людьми. */
export function SiteActivityPage() {
  const scope = useSiteScope();

  if (scope === null) {
    return null;
  }

  if (!scope.loading && !scope.can('people.manage')) {
    return <EmptyState title={t.activity.title} description={t.team.noAccess} />;
  }

  return (
    <div className={styles['page']}>
      <header className={styles['head']}>
        <h1 className={styles['title']}>{t.activity.title}</h1>
        <p className={styles['subtitle']}>{t.activity.siteSubtitle}</p>
      </header>

      <ActivityFeed
        queryKey={['activity', 'site', scope.siteId]}
        fetchPage={(cursor: Cursor | undefined) =>
          unwrapPage(activitySite(scope.siteId, { limit: 50, ...cursor }))
        }
      />
    </div>
  );
}

/** Журнал всей платформы — её владельцу. */
export function PlatformActivityPage() {
  return (
    <div className={styles['page']}>
      <header className={styles['head']}>
        <h1 className={styles['title']}>{t.activity.title}</h1>
        <p className={styles['subtitle']}>{t.activity.platformSubtitle}</p>
      </header>

      <ActivityFeed
        queryKey={['activity', 'platform']}
        showSite
        fetchPage={(cursor: Cursor | undefined) =>
          unwrapPage(activityPlatform({ limit: 50, ...cursor }))
        }
      />
    </div>
  );
}
